/* eslint-disable */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  makeStyles,
  RACSearchDropdown,
  RACTextField,
  Typography,
  RACButton,
  RACCOLOR,
  RACToggle,
  Box,
} from '@rentacenter/racstrap';

import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { AppRoute } from '../../config/route-config';
import { ReactComponent as BarCodeIcon } from '../../assets/img/barcode.svg';
import { ReactComponent as RcptAvailableIcon } from '../../assets/img/RcptAvailable.svg';
import { ReactComponent as RcptNtAvailableIcon } from '../../assets/img/RcptNtAvailable.svg';
import { isTablet, isMobile, isDesktop } from 'react-device-detect';

import {
  emptyField,
  INPUT_MAX_LENGTH,
  NONE_OPTIONS,
  PoFormField,
  PoFormLabel,
  poSubTypeForWhichFieldIsRequired,
  VALIDATIONS,
} from '../../constants/constants';
import { useGlobalContext } from '../../context/global/GlobalContext';
import {
  PurchaseOrderFormValues,
  QrScannerOutput,
  SelectFieldOption,
} from '../../types/types';
import { isNonEmptyValue } from '../../utils/utils';
import { AlertModal } from '../POs/AlertModal';
import { DeletePOConfirmModal } from '../POs/DeletePOConfirmModal';
import { DELETE_SUCCESS } from '../POs/POTable';
import { DuplicatePoState } from './useDuplicatePo';
import { useUserPermissions } from '../../context/permission/PermissionsProvider';
import { checkFlag, checkFlags, FlagSetTo } from '../../common/ConfigFlags';

import { QrScannerModal } from '../POs/QrScannerModal';

import { ReceiptNotAvailableModal } from '../POs/ReceiptNotAvailableModal';
import { useUserStateContext } from '../../context/user/user-contexts';
import { ReceiptNAwithSameUserModal } from '../POs/ReceiptNAwithSameUserModal';
import { CameraDetectConfirmModal } from '../POs/CameraDetectConfirmModal';
import { CameraCaptureModal } from '../POs/CameraCaptureModal';
import { ReceiptAvailableModal } from '../POs/ReceiptAvailableModal';
import { getReceipt } from '../../api/getReceipt';
import { ScannedCategoryModal } from '../POs/ScannedCategoryModal';

export interface DetailsTitleProps {
  purchaseOrder: PurchaseOrderFormValues | null;
  setInitDetailsValues: (input: QrScannerOutput) => void;
  purchaseOrderId?: string;
  disabled?: boolean;
  isEditMode?: boolean;
  isCanceled?: boolean;
  isLocalSourceRampLayout?: boolean;
  setIsCoupaOrPcrdSelected: (value: boolean) => void;
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    marginBottom: '1.5rem',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'space-between',
    marginTop: theme.typography.pxToRem(8),
  },
  field: {
    width: '17rem',
  },
  referenceField: {
    width: theme.typography.pxToRem(220),
  },
  barcodeClass: {
    width: theme.typography.pxToRem(60),
    height: theme.typography.pxToRem(30),
    padding: '0px',
    margin: '0px',
    marginTop: '0px',
  },
  receiptIconClass: {
    width: theme.typography.pxToRem(40),
    height: theme.typography.pxToRem(40),
    padding: '0px',
    margin: '0px',
    marginTop: '30px',
  },
  spaceBetween: {
    justifyContent: 'space-between',
  },
  row: {
    display: 'flex',
    gap: 32,
    marginTop: '0.5rem',
  },
  group: {
    display: 'flex',
    gap: 8,
    maxHeight: theme.typography.pxToRem(50),
  },
  input: {
    background: 'white',
  },
  infoSection: {
    display: 'flex',
    gap: theme.typography.pxToRem(32),
  },
  cancelButton: {
    backgroundColor: RACCOLOR.LINEN,
    padding: theme.typography.pxToRem(10),
    width: theme.typography.pxToRem(97),
    height: theme.typography.pxToRem(35),
    color: RACCOLOR.PUNCH,
    '&:hover': {
      backgroundColor: RACCOLOR.LINEN,
    },
  },
  badgeRoot: {
    margin: 'auto',
    padding: `${theme.typography.pxToRem(8)} ${theme.typography.pxToRem(36)}`,
    borderRadius: theme.typography.pxToRem(25),
    marginRight: theme.typography.pxToRem(18),
    background: 'silver',
    color: 'white',
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 600,
  },
}));

export const DetailsTitle = ({
  purchaseOrder,
  disabled,
  purchaseOrderId,
  isEditMode,
  isCanceled,
  isLocalSourceRampLayout,
  setInitDetailsValues,
  setIsCoupaOrPcrdSelected,
}: DetailsTitleProps) => {
  const classes = useStyles();
  const { poSubTypes } = useGlobalContext();
  const history = useHistory<DuplicatePoState>();
  const [poTypeValue, setPoTypeValue] = useState<SelectFieldOption>(emptyField);
  const [referenceNumberValue, setReferenceNumberValue] = useState('');
  const [referenceNumberErrorMessage, setReferenceNumberErrorMessage] =
    useState('');
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openAlertModal, setOpenAlertModal] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('');
  const [isDuplicatePO, setIsDuplicatePO] = useState(false);

  const [enableScanner, setEnableScanner] = useState(false);
  const [scannerAllowed, setscannerAllowed] = useState(true);
  const [enableMPOonWeb, setEnableMPOonWeb] = useState(false);
  const [enableMPOReceiptCapture, setEnableMPOReceiptCapture] = useState(false);

  const cameraDetected = useRef(false);
  const [noMatchFound, setNoMatchFound] = useState(false);
  const [keepSelectionPopup, setKeepSelectionPopup] = useState(false);
  const [qrPopUpOn, setQrPopUpOn] = useState(false);

  const [sameUserReceiptPopUp, setSameUserReceiptPopUp] = useState(false);
  const [receiptNAModal, setReceiptNAModal] = useState(false);
  const [receiptAvailableModal, setreceiptAvailableModal] = useState(false);
  const [appNotInTabPopUp, setAppNotInTabPopUp] = useState(false);
  const [appInTabPopUp, setAppInTabPopUp] = useState(false);
  const [showCameraModal, setShowCameraModal] = useState(false);
  const [showCameraForRetake, setshowCameraForRetake] = useState(false);
  const [showCameraForRetakeInApp, setshowCameraForRetakeInApp] = useState(false);
   const [qrScannerOutput, setQrScannerOutput] =  useState<QrScannerOutput>({});
  const { user } = useUserStateContext();

  const [base64Image, setBase64Image] = useState(
    '' // base64 string
  );

  const { setValue, errors } = useFormContext();
  const { poSubtypeRequired } = useUserPermissions();

  const onChangePOType = (e: any) => {
    setValue(PoFormField.PurchaseOrderSubType, e.value);
    setPoTypeValue({ value: e.value, label: e.label });
    const allowed = ["COUPA", "PCRD"];
    setIsCoupaOrPcrdSelected(allowed.includes(e?.value));
  };

  const onChangeReferenceNumber = (e: any) => {
    if (e?.length <= INPUT_MAX_LENGTH) {
      setReferenceNumberErrorMessage('');
    }
    setValue(PoFormField.ReferenceNumber, e);
    setReferenceNumberValue(e);
  };

  const handleDeletePOModalResolve = (value: string) => {
    value === 'success'
      ? setAlertMessage(DELETE_SUCCESS)
      : setAlertMessage(value);
    value === 'success' ? setAlertType('success') : setAlertType('error');
    setOpenDeleteModal(false);
    setOpenAlertModal(true);
  };

  const handleAlertClose = () => {
    setOpenAlertModal(false);
    history.push({ pathname: AppRoute.POs, search: '?draft' });
  };

  const poSubType: string | undefined = useWatch({
    name: PoFormField.PurchaseOrderSubType,
  });

  const setAccess = (flags: FlagSetTo[]) => {
    flags.forEach((oneFlag) => {
      if (oneFlag.flagName == 'EnableMPOonWeb') {
        setEnableMPOonWeb(oneFlag.flagValue);
      }

      if (oneFlag.flagName == 'ScannerTestDevice') {
        if (oneFlag.flagValue) {
          setscannerAllowed(
            cameraDetected.current && (isTablet || isDesktop || isMobile)
          );
        } else {
          setscannerAllowed(cameraDetected.current && (isTablet || isMobile));
        }
      }
    });
  };

  const referenceNumberIsRequired =
    poSubType === poSubTypeForWhichFieldIsRequired;
  const showReferenceNumberAsRequired =
    referenceNumberIsRequired || isLocalSourceRampLayout;
  const referenceNumberFieldErrorMessage = errors[PoFormField.ReferenceNumber]
    ? VALIDATIONS[PoFormField.ReferenceNumber]
    : referenceNumberErrorMessage;

  useEffect(() => {
    const checkMPOFlags = async () => {
      const storeNumber = window.sessionStorage.getItem('storeNumber');
      if (storeNumber) {
        const flagIs: FlagSetTo[] = await checkFlags(
          ['EnableMPOonWeb', 'ScannerTestDevice'],
          storeNumber
        );
        setAccess(flagIs);
        const receiptFlag = await checkFlag('EnableMPOReceiptCapture', storeNumber);
        setEnableMPOReceiptCapture(receiptFlag);
      }
    };
    checkMPOFlags();
  }, []);

  useEffect(() => {
    if (errors[PoFormField.ReferenceNumber]) {
      setReferenceNumberErrorMessage(VALIDATIONS[PoFormField.ReferenceNumber]);
    } else {
      setReferenceNumberErrorMessage('');
    }
  }, [errors]);

  const preFillRmsInformation = (
    preFilledValues: QrScannerOutput | undefined
  ) => {
    // update the combo boxes with the object's value

    popUpQRScanner(false);
    if (preFilledValues) {
      setInitDetailsValues(preFilledValues);
      setQrScannerOutput(preFilledValues);
      setAlertType('success'); 
      setAlertMessage(`Keep the defaulted scanned categories: <br></br><b>Department: </b> ${preFilledValues?.department} 
        <br></br><b> Sub-Department:  </b> ${preFilledValues?.subDepartment}  
        <br></br><b>Bracket:  </b> ${preFilledValues?.bracket}  
       <br></br><b> Type:  </b> ${preFilledValues?.type} 
       <br></br><b>Sub-Type:  </b> ${preFilledValues?.subType} ` )
      setKeepSelectionPopup(true);
    } else {
      setNoMatchFound(true);
      const newObj = {
      scanMatchIdentifier: 'A', // A = scanned, but didn’t find a match, required manual adjustment
    };
    setInitDetailsValues(newObj);
    }
  };

  const popUpQRScanner = (popIt: boolean) => {
    if (popIt) {
      setQrPopUpOn(true);
      setEnableScanner(true);
    } else {
      setQrPopUpOn(false);
      setEnableScanner(false);
    }
  };

  const lookForCamera = async (): Promise<boolean> => {
    if (!navigator.mediaDevices?.enumerateDevices) {
      return false;
    }

    const devices = await navigator.mediaDevices.enumerateDevices();
    const videoInputs = devices.filter((d) => d.kind === 'videoinput');

    return videoInputs.length > 0;
  };

  useEffect(() => {
    // check here
    const performScannerChecks = async () => {
      const cameraPresent = await lookForCamera();

      cameraDetected.current = cameraPresent;
    };

    performScannerChecks();
  }, []);

  useEffect(() => {
    if (purchaseOrder?.purchaseOrderSubType) {
      const selectedOption = poSubTypes.find(
        (opt: any) => opt.value === purchaseOrder.purchaseOrderSubType
      );
      setPoTypeValue(selectedOption as any);
    }
    if (purchaseOrder?.referenceNumber && !isDuplicatePO) {
      setReferenceNumberValue(purchaseOrder?.referenceNumber);
    }
  }, [poSubTypes, purchaseOrder, setValue]);

  useEffect(() => {
    if (history?.location?.state?.duplicatePO) {
      setIsDuplicatePO(true);
      onChangeReferenceNumber('');
    }
  }, [history?.location?.state?.duplicatePO]);

  const getReceiptImage = async (mpoNumber: string) => {
    // call API to get receipt image
    try {
      const receiptResponse = await getReceipt(mpoNumber);
      // eslint-disable-next-line no-console
      console.log('receipt', receiptResponse);
      if (receiptResponse.length != 0) {
        setBase64Image(receiptResponse.fileObject);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Failed to load receipt:', err);
      throw err;
    }
  };

  const handleReceiptClickResolve = async () => {
    const isFileInS3 = purchaseOrder?.isRcptAvailable;
    // eslint-disable-next-line no-console
    console.log('purchaseOrder.createdBy', purchaseOrder?.createdBy);
    const sameUser = purchaseOrder?.createdBy === user?.employeeId;

    if (isFileInS3) {
      if (sameUser) {
        if (scannerAllowed) {
          setreceiptAvailableModal(isFileInS3);
          setshowCameraForRetakeInApp(true);
          await getReceiptImage(String(purchaseOrder?.id));
        } else {
          await getReceiptImage(String(purchaseOrder?.id));
          setAppInTabPopUp(!scannerAllowed);
          setreceiptAvailableModal(isFileInS3);
        }
      } else {
        await getReceiptImage(String(purchaseOrder?.id));
        setAppInTabPopUp(false);
        setAppNotInTabPopUp(false);
        setreceiptAvailableModal(isFileInS3);
      }
    } else {
      setSameUserReceiptPopUp(sameUser);
      setReceiptNAModal(true);
      if (sameUser) {
        if (scannerAllowed) {
          setAppInTabPopUp(scannerAllowed);
          setAppNotInTabPopUp(!scannerAllowed);
        } else {
          setAppInTabPopUp(!scannerAllowed);
          setAppNotInTabPopUp(scannerAllowed);
        }
      } else {
        setAppInTabPopUp(false);
        setAppNotInTabPopUp(false);
      }
    }
  };

  const renderReceiptModals = () => (
    <>
      {receiptNAModal && !sameUserReceiptPopUp && (
        <ReceiptNotAvailableModal
          onClose={() => {
            setReceiptNAModal(false);
          }}
          onResolve={() => {
            setReceiptNAModal(false);
          }}
        />
      )}
      {appNotInTabPopUp && (
        <ReceiptNAwithSameUserModal
          onClose={() => {
            setReceiptNAModal(false);
            setAppNotInTabPopUp(false);
          }}
          onResolve={() => {
            setReceiptNAModal(false);
            setAppNotInTabPopUp(false);
          }}
        />
      )}
      {appInTabPopUp && (
        <CameraDetectConfirmModal
          onClose={() => {
            setReceiptNAModal(false);
            setAppInTabPopUp(false);
          }}
          message={'Receipt has not been saved for this purchase order,'}
          onResolve={() => {
            setReceiptNAModal(false);
            setAppInTabPopUp(false);
            setShowCameraModal(true);
          }}
        />
      )}
      {showCameraModal && (
        <CameraCaptureModal
          manualPurchaseOrderId={String(purchaseOrder?.purchaseOrderId)}
          mpoNumber={String(purchaseOrder?.id)}
          rmsItemNumber={String(purchaseOrder?.rmsItemNumber)}
          isOpen={showCameraModal}
          onClose={() => setShowCameraModal(false)}
          onSave={() => {
            setShowCameraModal(false);
          }}
        />
      )}
      {receiptAvailableModal && (
        <ReceiptAvailableModal
          onClose={() => {
            setreceiptAvailableModal(false);
            setReceiptNAModal(false);
            setAppInTabPopUp(false);
            setshowCameraForRetake(scannerAllowed);
          }}
          onResolve={() => {
            setreceiptAvailableModal(false);
            setReceiptNAModal(false);
          }}
          fileInBase64={base64Image}
        />
      )}
      {showCameraForRetake && showCameraForRetakeInApp && (
        <CameraDetectConfirmModal
          onClose={() => {
            setReceiptNAModal(false);
            setAppInTabPopUp(false);
            setshowCameraForRetake(false);
            setshowCameraForRetakeInApp(false);
          }}
          message={'You can recapture the receipt or keep the current by skipping.'}
          onResolve={() => {
            setReceiptNAModal(false);
            setAppInTabPopUp(false);
            setShowCameraModal(true);
          }}
        />
      )}
    </>
  );

  const isCancelledLabelVisible = isCanceled && !isDuplicatePO;

  const handleAdjustSelection = (value: any) => {
    const newObj = {
      isScannedCategoryKept: value,
      scanMatchIdentifier: 'P', // P = scanned item is a partial match with the RMS and requires manual adjustment,
    };
    setInitDetailsValues(newObj);
    setKeepSelectionPopup(false);
   
  };


  // Handler for when user confirms opt-out in popup
  const handleKeepSelection = (value: any) => {
    const newObj = {
      ...qrScannerOutput,
      isScannedCategoryKept: value,
      scanMatchIdentifier: 'S', // S = scanned item matches RMS
    };
    setInitDetailsValues(newObj);
    setKeepSelectionPopup(false);
 
  };

  return (
    <div className={classes.root}>
      <div className={classes.column}>
        <Typography noWrap variant="h4">
          {purchaseOrderId ? `PO# ${purchaseOrderId}` : 'Create PO'}
        </Typography>
        <div className={clsx(classes.row, classes.spaceBetween)}>
          <div className={classes.infoSection}>
            {!!poSubTypes?.length && (
              <div className={classes.group}>
                <span className={classes.field}>
                  <Controller
                    name={PoFormField.PurchaseOrderSubType}
                    rules={{ required: poSubtypeRequired }}
                    required
                    render={({ name }) => (
                      <RACSearchDropdown
                        required={poSubtypeRequired}
                        inputLabel={PoFormLabel.PurchaseOrderSubType}
                        disabled={disabled}
                        name={name}
                        options={
                          poSubtypeRequired
                            ? poSubTypes
                            : [NONE_OPTIONS, ...poSubTypes]
                        }
                        errormessage={
                          isLocalSourceRampLayout &&
                          errors?.[PoFormField.PurchaseOrderSubType]
                            ? `${PoFormLabel.PurchaseOrderSubType} is required`
                            : ''
                        }
                        OnChange={onChangePOType}
                        value={poTypeValue}
                      />
                    )}
                  />
                </span>
              </div>
            )}

            <div className={classes.group}>
              <span className={classes.referenceField}>
                <Controller
                  name={PoFormField.ReferenceNumber}
                  rules={{
                    required: showReferenceNumberAsRequired,
                    maxLength: INPUT_MAX_LENGTH,
                    validate: (value) => isNonEmptyValue(value),
                  }}
                  render={({ name }) => (
                    <RACTextField
                      label={PoFormLabel.ReferenceNumber}
                      disabled={disabled}
                      classes={{
                        input: classes.input,
                      }}
                      required={showReferenceNumberAsRequired}
                      type="text"
                      onChange={onChangeReferenceNumber}
                      value={referenceNumberValue || ''}
                      name={name}
                      errorMessage={referenceNumberFieldErrorMessage}
                    />
                  )}
                />
              </span>
              {enableMPOonWeb && !purchaseOrderId && (
                <div className={classes.group}>
                  <div className={classes.column}>
                    <span
                      style={{
                        padding: '0px',
                        paddingLeft: '30px',
                        marginTop: '0px',
                        position: 'relative',
                        top: '-10px',
                      }}
                    >
                      <Typography
                        variant="body1"
                        style={{ padding: '0px', marginTop: '0px' }}
                      >
                        <BarCodeIcon className={classes.barcodeClass} />
                        <span
                          style={{
                            paddingLeft: '10px',
                            marginTop: '0px',
                            position: 'relative',
                            top: '-10px',
                          }}
                        >
                          Enable Scanner
                        </span>
                      </Typography>
                      <Box ml={10}>
                        <RACToggle
                          toggleColor="blue"
                          style={{
                            padding: '0px',
                            marginTop: '0px',
                          }}
                          disabled={!scannerAllowed}
                          checked={enableScanner}
                          OnClick={() => setEnableScanner(!enableScanner)}
                          OnChange={() => popUpQRScanner(!enableScanner)}
                        />
                      </Box>
                    </span>
                  </div>
                </div>
              )}
            </div>
              {enableMPOReceiptCapture && purchaseOrderId && (
                <div className={classes.group}>
                  <div className={classes.column}>
                    <span
                      style={{
                        padding: '0px',
                        paddingLeft: '30px',
                        marginTop: '0px',
                        position: 'relative',
                        top: '-10px',
                      }}
                    >
                      <Typography
                        variant="body1"
                        style={{ padding: '0px', marginTop: '0px' }}
                      >
                        {purchaseOrder?.isRcptAvailable ? (
                          <RcptAvailableIcon
                            className={classes.receiptIconClass}
                          />
                        ) : (
                          <RcptNtAvailableIcon
                            className={classes.receiptIconClass}
                          />
                        )}
                        <span
                          style={{
                            paddingLeft: '-500px',
                            position: 'relative',
                            top: '-20px',
                            textDecoration: 'underline',
                          }}
                        >
                          <a
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleReceiptClickResolve()}
                          >
                            Receipt
                          </a>
                        </span>
                      </Typography>
                    </span>
                  </div>
                </div>
              )}
          </div>
          {isEditMode && (
            <RACButton
              variant="contained"
              color="primary"
              className={classes.cancelButton}
              onClick={() => setOpenDeleteModal(true)}
            >
              Delete
            </RACButton>
          )}
          {isCancelledLabelVisible && (
            <div className={classes.badgeRoot}>Cancelled</div>
          )}

          {qrPopUpOn && (
            <QrScannerModal
              open={qrPopUpOn}
              onClose={() => {
                setQrPopUpOn(false);
                setEnableScanner(false);
              }}
              onResolve={(value) => preFillRmsInformation(value)}
            />
          )}
          {openDeleteModal && purchaseOrderId && (
            <DeletePOConfirmModal
              id={purchaseOrderId}
              onClose={() => setOpenDeleteModal(false)}
              onResolve={(value) => handleDeletePOModalResolve(value)}
            />
          )}
          {noMatchFound && (
            <AlertModal
              alertMessage={
                'Unable to locate RMS Information for barcode/qr code.  Please manually select the options.'
              }
              alertType={'error'}
              onClose={() => setNoMatchFound(false)}
            />
          )}
          {keepSelectionPopup ? (
        <ScannedCategoryModal
          alertType={alertType}
          alertMessage={alertMessage}
          onAdjustFn={(value) =>  handleAdjustSelection(value)}
          onKeepFn={(value) => handleKeepSelection(value)} 
        />
      ) : null}
          {openAlertModal && (
            <AlertModal
              alertMessage={alertMessage}
              alertType={alertType}
              onClose={handleAlertClose}
            />
          )}
          {renderReceiptModals()}
        </div>
      </div>
    </div>
  );
};
